import { SITE } from '../data/site'
import './SubscribeCTA.css'

export function SubscribeCTA() {
  return (
    <section className="subscribe-cta section">
      <div className="container subscribe-cta__inner">
        <div>
          <p className="eyebrow">YouTube</p>
          <h2>தெய்வீக ஓசையைப் பின்தொடருங்கள்</h2>
          <p>புதிய பக்திப் பாடல்கள், ஸ்துதிகள் மற்றும் ஆன்மீக உள்ளடக்கம் — முதலில் YouTube-இல்.</p>
        </div>
        <div className="btn-row">
          <a
            className="btn btn--gold"
            href={SITE.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackYoutubeClick('channel')}
          >
            YouTube-ல் கேளுங்கள்
          </a>
          <a
            className="btn btn--ghost"
            href={SITE.youtubeSubscribeUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackYoutubeClick('subscribe')}
          >
            Subscribe
          </a>
        </div>
      </div>
    </section>
  )
}

function trackYoutubeClick(label: string) {
  const w = window as Window & { gtag?: (...args: unknown[]) => void }
  w.gtag?.('event', 'youtube_click', { event_label: label })
}
